// productService.js - 产品服务

export const getProducts = async () => {
  try {
    const response = await fetch('/api/products?populate=*');
    const result = await response.json();
    return { data: result.data };
  } catch (error) {
    console.error('获取产品失败:', error);
    // 返回模拟数据
    return {
      data: [
        { id: 1, Name: '示例产品1', Description: '产品描述', Images: [] },
        { id: 2, Name: '示例产品2', Description: '产品描述', Images: [] }
      ]
    };
  }
};

export const getCategories = async () => {
  try {
    const response = await fetch('/api/categories');
    const result = await response.json();
    return { data: result.data };
  } catch (error) {
    console.error('获取分类失败:', error);
    return { data: [] };
  }
};
